import _objectSpread from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "header"
};
var _hoisted_2 = {
  class: "header-text"
};
var _hoisted_3 = {
  class: "header-close-icon"
};
var _hoisted_4 = {
  class: "read-status-counter-container"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "status-text"
};
var _hoisted_7 = {
  class: "status-count"
};
var _hoisted_8 = {
  class: "read-status-member-list"
};
var _hoisted_9 = {
  key: 0,
  class: "empty-list-tip"
};
var _hoisted_10 = {
  class: "username"
};
var _hoisted_11 = {
  class: "username"
};
var _hoisted_12 = {
  key: 2,
  class: "fetch-more-container"
};
import { ref, onMounted, watch, nextTick } from '../../../../adapter-vue';
import { TUIStore, TUIChatService, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import closeIcon from '../../../../assets/icon/icon-close.svg';
import Icon from '../../../common/Icon.vue';
import Overlay from '../../../common/Overlay/index.vue';
import Avatar from '../../../common/Avatar/index.vue';
import FetchMore from '../../../common/FetchMore/index.vue';
import { isMobile } from '../../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: {
      default: () => ({})
    }
  },
  emits: ["setReadReceiptPanelVisible"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var lastUnreadCursor = '';
    var lastReadCursor = '';
    var tabNameList = ['unread', 'read'];
    var isListFetchCompleted = {
      unread: false,
      read: false,
      close: false
    };
    var isPullDownFetching = ref(false);
    var isPanelClose = ref(false);
    var isFirstLoadFinished = ref(false);
    var isStopFetchMore = ref(false);
    var currentTabName = ref('unread');
    var tabInfo = ref(generateInitalTabInfo());
    onMounted(/*#__PURE__*/_asyncToGenerator(function* () {
      yield initAndRefetchReceiptInfomation();
      nextTick(() => {
        isFirstLoadFinished.value = true;
      });
    }));
    watch(
    // uniapp下监听不到数据变化
    () => props.message.readReceiptInfo.readCount, () => {
      initAndRefetchReceiptInfomation();
    });
    function fetchGroupMessageRecriptMemberListByType() {
      return _fetchGroupMessageRecriptMemberListByType.apply(this, arguments);
    }
    function _fetchGroupMessageRecriptMemberListByType() {
      _fetchGroupMessageRecriptMemberListByType = _asyncToGenerator(function* () {
        var readType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
        var message = TUIStore.getMessageModel(props.message.ID);
        var unreadResult = {};
        var readResult = {};
        if (readType === 'all' || readType === 'unread') {
          unreadResult = yield TUIChatService.getGroupMessageReadMemberList({
            message,
            filter: 1,
            cursor: lastUnreadCursor,
            count: 100
          });
          if (unreadResult) {
            lastUnreadCursor = unreadResult.data.cursor;
            if (unreadResult.data.isCompleted) {
              isListFetchCompleted.unread = true;
            }
          }
        }
        if (readType === 'all' || readType === 'read') {
          readResult = yield TUIChatService.getGroupMessageReadMemberList({
            message,
            filter: 0,
            cursor: lastReadCursor,
            count: 100
          });
          if (readResult) {
            lastReadCursor = readResult.data.cursor;
            if (readResult.data.isCompleted) {
              isListFetchCompleted.read = true;
            }
          }
        }
        // Fetch the total number of read and unread users
        var {
          unreadCount: totalUnreadCount,
          readCount: totalReadCount
        } = message.readReceiptInfo;
        return {
          unreadResult: _objectSpread({
            count: totalUnreadCount
          }, unreadResult.data),
          readResult: _objectSpread({
            count: totalReadCount
          }, readResult.data)
        };
      });
      return _fetchGroupMessageRecriptMemberListByType.apply(this, arguments);
    }
    function pullDownFetchMoreData() {
      return _pullDownFetchMoreData.apply(this, arguments);
    }
    /**
     * Initializes and refetches receipt information.
     *
     * @return {Promise<void>} A promise that resolves when the function has completed.
     */
    function _pullDownFetchMoreData() {
      _pullDownFetchMoreData = _asyncToGenerator(function* () {
        /**
         * 使用 isPullDownFetching 控制 FetchMore 组件的状态
         * 顺便同时做 uniapp 下的 intersectionObserver 的加锁
         * 因为 uniapp 下 没有 isIntersecting 无法判断被观察的元素进入还是退出观察区
         */
        if (isListFetchCompleted[currentTabName.value] || isPullDownFetching.value) {
          return;
        }
        isPullDownFetching.value = true;
        if (currentTabName.value === 'unread' || currentTabName.value === 'read') {
          var {
            unreadResult,
            readResult
          } = yield fetchGroupMessageRecriptMemberListByType(currentTabName.value);
          checkStopFetchMore();
          try {
            tabInfo.value.unread.memberList = tabInfo.value.unread.memberList.concat(unreadResult.unreadUserInfoList || []);
            tabInfo.value.read.memberList = tabInfo.value.read.memberList.concat(readResult.readUserInfoList || []);
          } finally {
            isPullDownFetching.value = false;
          }
        }
      });
      return _pullDownFetchMoreData.apply(this, arguments);
    }
    function initAndRefetchReceiptInfomation() {
      return _initAndRefetchReceiptInfomation.apply(this, arguments);
    }
    /**
     * Checks if the fetch more operation should be stopped
     * by IntersetctionObserver.disconnect().
     *
     * @return {void}
     */
    function _initAndRefetchReceiptInfomation() {
      _initAndRefetchReceiptInfomation = _asyncToGenerator(function* () {
        lastUnreadCursor = '';
        lastReadCursor = '';
        isStopFetchMore.value = false;
        isListFetchCompleted.unread = false;
        isListFetchCompleted.read = false;
        var {
          unreadResult,
          readResult
        } = yield fetchGroupMessageRecriptMemberListByType('all');
        checkStopFetchMore();
        resetTabInfo('read', readResult.count, readResult.readUserInfoList);
        resetTabInfo('unread', unreadResult.count, unreadResult.unreadUserInfoList);
        resetTabInfo('close');
      });
      return _initAndRefetchReceiptInfomation.apply(this, arguments);
    }
    function checkStopFetchMore() {
      if (isListFetchCompleted.read && isListFetchCompleted.unread) {
        isStopFetchMore.value = true;
      }
    }
    /**
     * Resets the information of a specific tab.
     *
     * @param {TabName} tabName - The name of the tab to reset.
     * @param {number} [count] - The count to assign to the tab. Optional.
     * @param {IMemberData[]} [memberList] - The list of members to assign to the tab. Optional.
     * @return {void} - This function does not return anything.
     */
    function resetTabInfo(tabName, count, memberList) {
      tabInfo.value[tabName].count = count;
      tabInfo.value[tabName].memberList = memberList || [];
    }
    /**
     * Generates the initial tab information.
     *
     * @return {ITabInfo} The initial tab information.
     */
    function generateInitalTabInfo() {
      return {
        read: {
          tabName: TUITranslateService.t('TUIChat.已读'),
          count: undefined,
          memberList: []
        },
        unread: {
          tabName: TUITranslateService.t('TUIChat.未读'),
          count: undefined,
          memberList: []
        },
        close: {
          tabName: TUITranslateService.t('TUIChat.关闭'),
          count: undefined,
          memberList: []
        }
      };
    }
    /**
     * Toggles the tab name.
     *
     * @param {TabName} tabName - The name of the tab to toggle.
     * @return {void} This function does not return anything.
     */
    function toggleTabName(tabName) {
      currentTabName.value = tabName;
    }
    function closeReadReceiptPanel() {
      isPanelClose.value = true;
      setTimeout(() => {
        emits('setReadReceiptPanelVisible', false);
      }, 200);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(Overlay, {
        useMask: false,
        onOnOverlayClick: closeReadReceiptPanel
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass({
            'read-receipt-panel': true,
            'read-receipt-panel-mobile': _unref(isMobile),
            'read-receipt-panel-close-mobile': _unref(isMobile) && _unref(isPanelClose)
          })
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(TUITranslateService).t("TUIChat.消息详情")), 1), _createElementVNode("div", _hoisted_3, [_createVNode(Icon, {
          size: "12px",
          hotAreaSize: "8",
          file: _unref(closeIcon),
          onOnClick: closeReadReceiptPanel
        }, null, 8, ["file"])])]), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabNameList, tabName => {
          return _createElementVNode("div", {
            key: tabName,
            class: _normalizeClass({
              'read-status-counter': true,
              'active': tabName === _unref(currentTabName)
            }),
            onClick: $event => toggleTabName(tabName)
          }, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(tabInfo)[tabName].tabName), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(tabInfo)[tabName].count === undefined ? "" : _unref(tabInfo)[tabName].count), 1)], 10, _hoisted_5);
        }), 64))]), _createElementVNode("div", _hoisted_8, [_unref(tabInfo)[_unref(currentTabName)].count === 0 && _unref(isFirstLoadFinished) ? (_openBlock(), _createElementBlock("div", _hoisted_9, " - " + _toDisplayString(_unref(TUITranslateService).t('TUIChat.空')) + " - ", 1)) : _unref(isFirstLoadFinished) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_unref(currentTabName) === 'unread' ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(_unref(tabInfo)[_unref(currentTabName)].memberList, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.userID,
            class: "read-status-member-container"
          }, [_createVNode(Avatar, {
            class: "read-status-avatar",
            useSkeletonAnimation: "",
            url: item.avatar || ''
          }, null, 8, ["url"]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.nick || item.userID), 1)]);
        }), 128)) : _createCommentVNode("", true), _unref(currentTabName) === 'read' ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(_unref(tabInfo)[_unref(currentTabName)].memberList, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.userID,
            class: "read-status-member-container"
          }, [_createVNode(Avatar, {
            class: "read-status-avatar",
            useSkeletonAnimation: "",
            url: item.avatar
          }, null, 8, ["url"]), _createElementVNode("div", _hoisted_11, _toDisplayString(item.nick || item.userID), 1)]);
        }), 128)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _unref(isFirstLoadFinished) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(FetchMore, {
          isFetching: _unref(isPullDownFetching),
          isTerminateObserve: _unref(isStopFetchMore),
          onOnExposed: pullDownFetchMoreData
        }, null, 8, ["isFetching", "isTerminateObserve"])])) : _createCommentVNode("", true)])], 2)]),
        _: 1
      });
    };
  }
});